module.exports = __webpack_public_path__ + "img/github.ef7a02b6.png";